import actionTypes from './actionTypes';

export const addUserData = payload => ({ type: actionTypes.ADD_USER_DATA, payload });
